import { supabase } from '@/integrations/supabase/client';

export const logDemoAuditEvent = async (action: string, metadata?: Record<string, unknown>, summary?: string) => {
  try {
    const session = (await supabase.auth.getSession()).data.session;
    if (!session?.access_token) return;
    await supabase.functions.invoke('demo-audit', {
      headers: { Authorization: `Bearer ${session.access_token}` },
      body: {
        action,
        summary,
        metadata,
      },
    });
  } catch (error) {
    console.warn('Demo audit event failed', error);
  }
};
